__turbopack_context__.v({
  "caret": "OutletDetailsOpeningHours-module-scss-module__sIswFa__caret",
  "headerContainer": "OutletDetailsOpeningHours-module-scss-module__sIswFa__headerContainer",
  "openingHoursContainer": "OutletDetailsOpeningHours-module-scss-module__sIswFa__openingHoursContainer",
  "openingHoursGroups": "OutletDetailsOpeningHours-module-scss-module__sIswFa__openingHoursGroups",
  "outletOpeningHour": "OutletDetailsOpeningHours-module-scss-module__sIswFa__outletOpeningHour",
  "outletStateClosed": "OutletDetailsOpeningHours-module-scss-module__sIswFa__outletStateClosed",
  "outletStatus": "OutletDetailsOpeningHours-module-scss-module__sIswFa__outletStatus",
  "outletStatusContainer": "OutletDetailsOpeningHours-module-scss-module__sIswFa__outletStatusContainer",
  "outletStatusOpened": "OutletDetailsOpeningHours-module-scss-module__sIswFa__outletStatusOpened",
  "selectedOpeningHourOrderFormat": "OutletDetailsOpeningHours-module-scss-module__sIswFa__selectedOpeningHourOrderFormat",
});
